import { combineEpics } from 'redux-observable';
import { get } from 'lodash';

// services
import {
    Service as AnalyticsService,
    Constants as AnalyticsConstants
} from 'modules/analytics-provider';

// epics
import {
    analyticsEpicCreator,
    setLanguage,
    cleanLoginAnalyticsData,
} from 'modules/analytics-provider/analytics-provider.epic';

// constants
import {
    REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY
} from 'modules/language-provider/language-provider.constants';
import {
    REMOVE_LOGIN_SESSION,
    SET_LOGIN_SESSION,
    LOG_OUT_DONE
} from 'modules/login/login.constants';
import { WEBSITE_MODE } from '@sitegen/common/constants';

// types
import { IAction } from 'types/action';
import { IEpic } from 'types/epic';

export const setLanguageEpic = setLanguage([REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY]);
const cleanLoginAnalyticsDataEpic = cleanLoginAnalyticsData([REMOVE_LOGIN_SESSION]);

export const analyticLoginEpic = analyticsEpicCreator(
    [SET_LOGIN_SESSION],
    (action: IAction, store): void => {
        if (AnalyticsService.isAuthenticatedUser || store.value.config.mode === WEBSITE_MODE.EMBEDDED) {
            return;
        }

        const userId = get(action, 'payload.UbisoftConnectProfile.user.userId');
        AnalyticsService.updateAnalyticalData({ ubisoftId: userId, errorType: '' });

        AnalyticsService.sendAccountEvent({
            action: AnalyticsConstants.ANALYTICS_ATTRIBUTES.action.signedIn,
            loggedIn: 'true',
            loggedOut: 'false'
        });

        AnalyticsService.isAuthenticatedUser = true;
    }
);

export const analyticLogoutEpic = analyticsEpicCreator(
    [LOG_OUT_DONE],
    (_action: IAction, store): void => {
        AnalyticsService.platformSelection = '';
        if (store.value.config.mode === WEBSITE_MODE.EMBEDDED) {
            return;
        }
        AnalyticsService.sendAccountEvent({
            action: AnalyticsConstants.ANALYTICS_ATTRIBUTES.action.signedOut,
            loggedIn: 'false',
            loggedOut: 'true'
        });
        AnalyticsService.isAuthenticatedUser = false;
    }
);

/** Below epic was added for Friends Referral flow specifically.
 * Its purpose is automatically to opt-in cookies policy banner,
 * as it may be accepted elsewhere (in Ubisoft Connect for example).
 * So we consider successful login as the acceptance of cookies policy.
 */
const analyticsTriggerOptIn = analyticsEpicCreator([SET_LOGIN_SESSION], AnalyticsService.triggerOptIn);

export const analyticsEpics: IEpic = combineEpics(
    analyticsTriggerOptIn,
    analyticLoginEpic,
    analyticLogoutEpic,
    setLanguageEpic,
    cleanLoginAnalyticsDataEpic,
);

export default analyticsEpics;
